import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { default as webI18n } from "@sisuwellness/web-components/i18n";
import { fallbackLng } from "@sisuwellness/utilities/i18n/fallbackLanguage";
import { getDebugMode, getDevConfig } from "@sisuwellness/utilities/i18n/devConfig";

import enGbFlag from "flag-icons/flags/1x1/gb.svg"; // UK
import skFlag from "flag-icons/flags/1x1/sk.svg"; // Slovakia
import ukFlag from "flag-icons/flags/1x1/ua.svg"; // Ukraine
import dkFlag from "flag-icons/flags/1x1/dk.svg"; // Denmark
import seFlag from "flag-icons/flags/1x1/se.svg"; // Sweden
import nlFlag from "flag-icons/flags/1x1/nl.svg"; // Netherlands
import deFlag from "flag-icons/flags/1x1/de.svg"; // Germany
import frFlag from "flag-icons/flags/1x1/fr.svg"; // France
import plFlag from "flag-icons/flags/1x1/pl.svg"; // Poland
import esFlag from "flag-icons/flags/1x1/es.svg"; // Spain
import czFlag from "flag-icons/flags/1x1/cz.svg"; // Czech
import beFlag from "flag-icons/flags/1x1/be.svg"; // Belgium
import itFlag from "flag-icons/flags/1x1/it.svg"; // Italy
import fiFlag from "flag-icons/flags/1x1/fi.svg"; // Finland
import noFlag from "flag-icons/flags/1x1/no.svg"; // Norway
import lvFlag from "flag-icons/flags/1x1/lv.svg"; // Latvia
import huFlag from "flag-icons/flags/1x1/hu.svg"; // Hungary
import chFlag from "flag-icons/flags/1x1/ch.svg"; // Switzerland
import bnFlag from "flag-icons/flags/1x1/bd.svg"; // Bangladesh
import zhFlag from "flag-icons/flags/1x1/cn.svg"; // China
import ptFlag from "flag-icons/flags/1x1/pt.svg"; // Portugal

export const supportedLangs = [
    { code: "en-GB", name: "English", localName: "English", flag: enGbFlag },
    { code: "de-DE", name: "German", localName: "Deutsch", flag: deFlag },
    { code: "fr-FR", name: "French", localName: "Français", flag: frFlag },
    { code: "es-ES", name: "Spanish", localName: "Español", flag: esFlag },
    { code: "it-IT", name: "Italian", localName: "Italiano", flag: itFlag },
    { code: "pt-PT", name: "Portuguese", localName: "Português", flag: ptFlag },
    { code: "da-DK", name: "Danish", localName: "Dansk", flag: dkFlag },
    { code: "nl-NL", name: "Dutch", localName: "Nederlands", flag: nlFlag },
    { code: "nl-BE", name: "Flemish", localName: "Vlaams", flag: beFlag },
    { code: "sv-SE", name: "Swedish", localName: "Svenska", flag: seFlag },
    { code: "nn-NO", name: "Norwegian", localName: "Norsk", flag: noFlag },
    { code: "fi-FI", name: "Finnish", localName: "Suomalainen", flag: fiFlag },
    { code: "pl-PL", name: "Polish", localName: "Polski", flag: plFlag },
    { code: "cs-CZ", name: "Czech", localName: "Czech", flag: czFlag },
    { code: "sk-SK", name: "Slovakian", localName: "Slovenčina", flag: skFlag },
    { code: "uk-UA", name: "Ukranian", localName: "Українська", flag: ukFlag },
    { code: "lv-LV", name: "Latvian", localName: "Latviski", flag: lvFlag },
    { code: "hu-HU", name: "Hungarian", localName: "Magyar", flag: huFlag },
    { code: "de-CH", name: "Swiss German", localName: "Schweizerisch", flag: chFlag },
    {
        code: "zh-CN",
        name: "Chinese (Mandarin)",
        localName: "中文",
        flag: zhFlag
    },
    { code: "bn-BD", name: "Bengali", localName: "বাংলা", flag: bnFlag }
];

export const supportedLangsArray = supportedLangs.map(lang => lang.code);

export const supportedLangsMap = supportedLangs.reduce((acc, { code, ...rest }) => {
    acc[code] = rest;
    return acc;
}, {});

// SimpleLocalize configuration
const cdnBaseUrl = process.env.REACT_APP_SIMPLE_LOCALIZE_CDN;
const projectToken = process.env.REACT_APP_SIMPLE_LOCALIZE_PROJECT_TOKEN;
const environment = process.env.REACT_APP_SIMPLE_LOCALIZE_ENV;
const loadPath = `${cdnBaseUrl}/${projectToken}/${environment}/{{lng}}`;

export const i18nInit = i18n
    .use(LanguageDetector)
    .use(HttpApi)
    .use(initReactI18next)
    .init({
        debug: getDebugMode(process.env.REACT_APP_I18N_DEBUG),
        interpolation: { escapeValue: false },
        // Unified fallback strategy from utilities (single source of truth)
        fallbackLng,
        load: "currentOnly",
        // Retry configuration for failed translation loads
        retryTimeout: 350, // Milliseconds between retries (exponential backoff)
        maxRetries: 5, // Maximum number of retry attempts
        backend: {
            loadPath: loadPath
        },
        react: {
            useSuspense: true
        },
        returnObjects: true,
        returnEmptyString: false, // Don't return empty strings as valid translations
        // Enhanced dev config with better error messages (only in development)
        ...getDevConfig("members-portal-web")
    });

i18n.on("languageChanged", lng => {
    webI18n.changeLanguage(lng);
});

export default i18n;
